
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { FormField } from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

// Common amenities for commercial properties
const amenitiesOptions = [
  { id: 'parking', label: 'Parking' },
  { id: 'elevator', label: 'Elevator' },
  { id: 'security', label: 'Security' },
  { id: 'reception', label: 'Reception' },
  { id: 'meeting_rooms', label: 'Meeting Rooms' },
  { id: 'cafeteria', label: 'Cafeteria' },
  { id: 'air_conditioning', label: 'Air Conditioning' },
  { id: 'heating', label: 'Heating' },
  { id: 'generator', label: 'Backup Generator' },
  { id: 'internet', label: 'High Speed Internet' },
  { id: 'furnished', label: 'Furnished' },
  { id: 'loading_bay', label: 'Loading Bay' },
  { id: 'storage', label: 'Storage Space' },
  { id: 'kitchen', label: 'Kitchen Facilities' },
  { id: 'restrooms', label: 'Restrooms' },
  { id: 'shower', label: 'Shower Facilities' },
  { id: 'disabled_access', label: 'Disabled Access' },
  { id: 'fire_alarm', label: 'Fire Alarm System' },
  { id: 'sprinkler', label: 'Sprinkler System' },
  { id: 'cctv', label: 'CCTV' }
];

const AmenitiesSection = ({ form }: { form: any }) => {
  return (
    <Card className="overflow-hidden">
      <CardHeader>
        <CardTitle>Amenities & Features</CardTitle>
        <CardDescription>
          Select amenities and features available with this property
        </CardDescription>
      </CardHeader>
      <CardContent>
        <FormField
          control={form.control}
          name="amenities"
          render={({ field }) => (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {amenitiesOptions.map((amenity) => (
                <div className="flex items-center space-x-2" key={amenity.id}>
                  <Checkbox
                    id={`amenity-${amenity.id}`}
                    checked={field.value?.includes(amenity.id)}
                    onCheckedChange={(checked) => {
                      if (checked) {
                        field.onChange([...(field.value || []), amenity.id]);
                      } else {
                        field.onChange(
                          field.value?.filter((value: string) => value !== amenity.id) || []
                        );
                      }
                    }}
                  />
                  <Label htmlFor={`amenity-${amenity.id}`}>{amenity.label}</Label>
                </div>
              ))}
            </div>
          )}
        />
      </CardContent>
    </Card>
  );
};

export default AmenitiesSection;
